/**
 * Preferred public URL for each service slug (nav + SEO redirects).
 * Cavity install/removal intentionally keep both /services/* and /lp/* live; no redirect.
 */
export const SERVICE_CANONICAL_PATHS: Record<string, string> = {
  "cavity-wall-insulation-removal": "/lp/cavity-insulation-removal",
  "cavity-wall-insulation": "/lp/cavity-wall-insulation",
  "damp-and-mould-remediation": "/damp-survey",
  "loft-insulation": "/loft-insulation",
  "internal-wall-insulation": "/internal-wall-insulation",
  "remedial-wall-ties": "/remedial-wall-ties",
  "ventilation-and-extraction": "/ventilation-extraction",
  "boilers-and-heating": "/boilers-heating",
  "heating-controls": "/heating-controls",
  "air-source-heat-pumps": "/air-source-heat-pumps",
  "solar-pv": "/solar-pv",
};

/** Service slugs that keep /services/{slug} indexable alongside dedicated URLs. */
export const SERVICE_SLUGS_WITHOUT_REDIRECT = new Set([
  "cavity-wall-insulation",
  "cavity-wall-insulation-removal",
]);

export function getServiceRedirectPath(slug: string): string | null {
  if (SERVICE_SLUGS_WITHOUT_REDIRECT.has(slug)) return null;
  return SERVICE_CANONICAL_PATHS[slug] ?? null;
}

/** @deprecated Use SERVICE_CANONICAL_PATHS */
export const LP_SLUG_OVERRIDES = SERVICE_CANONICAL_PATHS;
